import React, { useEffect } from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import Icon from 'components/atoms/Icon';
import MbTooltip from 'components/atoms/MbTooltip';

const useStyles = makeStyles((theme) => ({
  tableInfoWrap: {
    '&.tableFilter': {
      paddingRight: 10,
      marginRight: 5,
      borderRight: '1px solid #e5e8eb',
    },
  },
}));

const ButtonWrap = (props) => {
  const classes = useStyles();
  const {
    children,
    icon = false,
    iconColor,
    placement = 'right-start',
    className,
    ...rest
  } = props;

  useEffect(() => {}, []);
  return (
    <>
      <MbTooltip
        className={clsx(classes.tableInfoWrap, className)}
        placement={placement}
        {...rest}
      >
        {icon !== false && <Icon icon={icon} color={iconColor} />}
        {children}
      </MbTooltip>
    </>
  );
};

export default ButtonWrap;
